import React from 'react';

import { StyledButton } from './styles';

const Button = ({ height, width, radius, color, fontSize, background, value, onClick, smallWidth, smallHeight }) => {
  return (
    <StyledButton height={height} width={width} radius={radius} color={color} fontSize={fontSize} background={background} onClick={onClick}>
      {value}
    </StyledButton>
  );
};

export default Button;
